// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //引入element-ui的样式文件
import 'mint-ui/lib/style.css'

// 引用vant组件
import Vant from 'vant';
import 'vant/lib/index.css';


import router from './router'
import VueWechatTitle from "vue-wechat-title"
import axios from 'axios'
import qs from 'qs'

Vue.use(Vant);

Vue.use(VueWechatTitle)
Vue.use(ElementUI) //通过这个命令使所有的element-ui标签(<el-*></el-*>)可被解析
Vue.use(Mint);
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs;

Vue.config.productionTip = false

//引入全局域名文件
import domain from '../src/domain/domain.js'
global.domain = domain;


document.body.addEventListener('touchstart', function () {});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js